import {
  ChartMark,
  WidgetKind,
  type Report,
  type WidgetOf,
} from 'corso-admin-ui';

export const newAndRetainedRevenue = {
  kind: WidgetKind.kpi,
  metric: 'totalRevenue',
} as const satisfies WidgetOf<'claims'>;

export const revenue = {
  key: 'revenue',
  label: 'Revenue',
  dataset: 'claims',
  timeFields: ['finalizedOn', 'createdOn'],
  widgets: [
    newAndRetainedRevenue,
    { kind: WidgetKind.kpi, metric: 'totalFees' },
    { kind: WidgetKind.kpi, metric: 'totalIncentives' },
    { kind: WidgetKind.kpi, metric: 'newRevenue' },
    { kind: WidgetKind.kpi, metric: 'retainedRevenue' },
    { kind: WidgetKind.kpi, metric: 'feesApplied' },
    { kind: WidgetKind.kpi, metric: 'returnShippingCharged' },
    { kind: WidgetKind.kpi, metric: 'giftCardIncentives' },
    { kind: WidgetKind.kpi, metric: 'shopNowIncentives' },
    {
      kind: WidgetKind.overTime,
      title: 'Revenue over time',
      description: 'New and retained revenue',
      mark: ChartMark.line,
      metrics: ['newRevenue', 'retainedRevenue'],
    },
  ],
} as const satisfies Report;
